<section class="hero-overlay-layout" [ngStyle]="heroContainerStyles()">
    <div
        class="hero-overlay-layout__content"
        [ngStyle]="{
            '--content-width': block().data.contentMaxWidth,
        }"
        [attr.data-text-color-override]="block().data.contentTextColor">
        <h1
            class="hero-overlay-layout__heading"
            [attr.data-has-custom-heading-typography]="hasCustomHeadingTypography() || null">
            {{ block().data.heading }}
        </h1>
        <div
            class="hero-overlay-layout__description"
            [innerHTML]="block().data.description"
            [attr.data-has-custom-description-typography]="hasCustomDescriptionTypography() || null"></div>
    </div>
</section>
